import { Stack, Typography, useTheme } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { Box, Tooltip } from '@monorepo/nova-ui';

interface LabelWithTooltipProps {
  label: string;
  tooltip: string;
  showIcon?: boolean;
  textColor?: string;
  textSize?: number;
}

export const LabelWithTooltip = ({
  label,
  tooltip,
  showIcon = true,
  textColor,
  textSize,
}: LabelWithTooltipProps) => {
  const theme = useTheme();
  return (
    <Stack direction="row" flex={1} gap={2} alignItems="center">
      <Typography
        variant="body2"
        sx={(theme) => ({
          color: textColor || theme.palette.text.second,
          fontSize: textSize ? `${textSize}px` : undefined,
          lineHeight: 1,
        })}
      >
        {label}
      </Typography>
      {showIcon && (
        <Tooltip title={tooltip}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <SystemIcon
              iconName="Question"
              size={textSize ? textSize : 16}
              color={textColor || theme.palette.text.second}
              sx={{
                cursor: 'pointer',
              }}
            />
          </Box>
        </Tooltip>
      )}
    </Stack>
  );
};
